import React from "react";
const DropdownItem = ({ href, seperator, children }) => {
  return (
    <React.Fragment>
      {seperator ? <div className="dropdown_seperator"></div> : null}
      <a href={href} className="dropdown_item">
        {children}
      </a>
    </React.Fragment>
  );
};
DropdownItem.defaultProps = {
  href: "/",
};
export default DropdownItem;
